import Vue from 'vue';
import axios from 'axios';
import VTooltip from 'v-tooltip';
import BeautifulChat from 'vue-beautiful-chat';
import VueAnalytics from 'vue-analytics';

import App from './app.vue';
import router from './router';
import store from './store';
import notificator from './services/notificator';

import './register-service-worker';
import './components';
import './plugins/element.js';

Vue.use(VTooltip);
Vue.use(BeautifulChat);
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_ID,
  router,
});

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// Add a response interceptor
axios.interceptors.response.use(
  (response) => response,
  (context) => {
    const data = context.response.data;

    if (data && data.errors) {
      notificator.error(data.errors[0]);
    }

    return Promise.reject(context);
  },
);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
